module.exports = __webpack_public_path__ + "images/landing/video-previews/Mountains_2x.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/landing/video-previews/Mountains_2x.jpg
// module id = 53gd
// module chunks = 1